import { Injectable, inject } from '@angular/core';

import { InspectionStatusDBService } from '../db/inspection-status-db-service';
import { Resolve } from '@angular/router';
import { InspectionStatusDto } from '@core/api';

@Injectable()
export class InspectionStatesResolver implements Resolve<InspectionStatusDto[]> {
  private inspectionStatusDBService = inject(InspectionStatusDBService);

  public resolve() {
    return this.inspectionStatusDBService.getInspectionStates();
  }
}
